import styled from 'styled-components';
export const StyledRefreshButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0.5rem;
  border-radius: 9px;
  font-size: 2rem;
  line-height: 150%;
  color: ${(props) => props.theme.button1};
  background: transparent;
  border: none;
  gap: 0.6rem;

  @media screen and (max-width: 1440px) {
    width: 4rem;
    height: 4rem;
    border: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2)};
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2)};
  }

  @media screen and (min-width: 1200px) {
    border: none;
    width: auto;
    height: auto;
    padding: 0.5rem;
  }

  @media screen and (max-width: 1200px) {
    height: 4.2rem;
    padding: 0.5rem 0.8rem;
  }

  @media screen and (max-width: 768px) {
    max-height: 3.7rem;
    max-width: 3.7rem;
  }

  &:hover {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg1 : props.theme.text2)};
    background-color: ${(props) =>
      props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2};
    cursor: pointer;
  }

  .button-icon {
    display: block;
    width: 2.4rem;
    height: 2.4rem;

    @media screen and (min-width: 1200px) {
      display: none;
    }

    *[fill] {
      fill: currentColor;
    }
  }

  .title {
    display: none;

    @media screen and (min-width: 1200px) {
      display: inline;
      font-size: 1.8rem;
    }

    @media screen and (min-width: 1440px) {
      font-size: 2rem;
    }
  }
`;
